/** Two letters for a name's avatar: the first and last word's first
 *  letters ("Maria Lopez" → "ML", "Cal Fire" → "CF", "Jordan" → "J").
 *  Shared by the People directory and the plan's "Who's doing it" list. */
export function initials(name: string): string {
  const words = name
    .trim()
    .split(/[\s,]+/)
    .filter(Boolean);
  if (words.length === 0) return '?';
  const first = words[0][0] ?? '';
  const last = words.length > 1 ? (words[words.length - 1][0] ?? '') : '';
  return (first + last).toUpperCase();
}
